import Initialiser from 'initialiser';
import { cloneDeep } from 'utils/immutable';
import constants from 'utils/constants';
import { logout } from 'ducks/modules/user';
import api from 'utils/api';

// ACTION TYPES
const START_FETCH_ROYALTIES = 'START_FETCH_ROYALTIES';
const UPDATED_ROYALTIES = 'UPDATED_ROYALTIES';

// SYNC ACTION CREATORS
export function startFetchRoyalties() {
    return { type: START_FETCH_ROYALTIES };
}
export function updatedRoyalties(royalties) {
    return { type: UPDATED_ROYALTIES, royalties };
}

// ASYNC ACTION CREATORS
export function fetchRoyalties(aggregation, filter) {
    return async (dispatch) => {
        dispatch(startFetchRoyalties());
        try {
            const royalties = await api.getRoyalties(aggregation, filter);
            dispatch(updatedRoyalties(royalties));
        } catch (err) {
            console.error('Error fetching royalties: ', err);
            dispatch(updatedRoyalties([]));
            if (err && err.status === constants.HttpCodes.UNAUTHORIZED) {
                return dispatch(logout(err.data === constants.ServerCodes.TOKEN_EXPIRED));
            } else if (err && err.status === constants.HttpCodes.FORBIDDEN) {
                return Initialiser.history.replace('/forbidden');
            } else if (err && err.status === constants.HttpCodes.BAD_REQUEST) {
                return Initialiser.history.replace('/notfound');
            }
        }
    };
}

// REDUCER
export default function reducer(state = Initialiser.initialState.royalties, action) {
    switch (action.type) {
        case UPDATED_ROYALTIES:
            return cloneDeep(action.royalties);
        default:
            return state;
    }
}
